import { useCallback } from 'react';
import { useUIStore, useGameStore } from '@/stores';
import './TurnTransitionModal.css';

/**
 * TurnTransitionModal - ターン遷移モーダル
 * ローカルモードでプレイヤー間のデバイス受け渡しを促すモーダルコンポーネント
 */
const TurnTransitionModal = () => {
  const { isOpen, nextPlayerName, nextPlayerId } = useUIStore(
    (state) => state.modals.turnTransition
  );
  const closeTurnTransition = useUIStore((state) => state.closeTurnTransition);
  const switchLocalPlayer = useGameStore((state) => state.switchLocalPlayer);

  /**
   * 準備完了ボタンのハンドラ
   * プレイヤーを切り替えてモーダルを閉じる
   */
  const handleReady = useCallback(() => {
    if (nextPlayerId) {
      switchLocalPlayer(nextPlayerId);
    }
    closeTurnTransition();
  }, [nextPlayerId, switchLocalPlayer, closeTurnTransition]);

  // ESCキーは意図的に無効（明示的な確認が必要）

  if (!isOpen) {
    return null;
  }

  return (
    <div className="TurnTransitionModal__overlay">
      <div className="TurnTransitionModal__modal">
        <div className="TurnTransitionModal__icon">HANDOVER</div>
        <h2 className="TurnTransitionModal__title">ターン交代</h2>
        <p className="TurnTransitionModal__message">
          デバイスを <strong>{nextPlayerName}</strong> に渡してください
        </p>
        <p className="TurnTransitionModal__hint">
          画面を見せる前に渡してください
        </p>
        <button
          className="TurnTransitionModal__button"
          onClick={handleReady}
          autoFocus
        >
          READY
        </button>
      </div>
    </div>
  );
};

export default TurnTransitionModal;
